import { LEGAL_BASIS_FOR_PROCESSING_CHECKBOX_NAME, LEGAL_BASIS_FOR_PROCESSING } from 'ui-forms-embed-components-library/components/base/fields/LegalBasisForProcessingField/LegalBasisForProcessingField';
export const moduleLegalBasisForProcessingResolvePropertyModules = module => {
  var _module$options, _module$options2;
  const legalBasisValue = (_module$options = module.options) === null || _module$options === void 0 || (_module$options = _module$options[0]) === null || _module$options === void 0 ? void 0 : _module$options.value;
  switch (legalBasisValue) {
    case LEGAL_BASIS_FOR_PROCESSING.FREELY_GIVEN_CONSENT:
      return [{
        id: module.id,
        type: 'singleCheckbox',
        propertyReference: LEGAL_BASIS_FOR_PROCESSING_CHECKBOX_NAME,
        label: (_module$options2 = module.options) === null || _module$options2 === void 0 || (_module$options2 = _module$options2[0]) === null || _module$options2 === void 0 ? void 0 : _module$options2.label,
        required: true,
        conditionallyHidden: false,
        triggerDependentRulesOnLoad: false
      }];
    default:
      return [];
  }
};